import type { IConfig } from '../interfaces/config'
import { CheckoutRules } from '../interfaces/config'

/**
 * Sorted CSV of the M1/M2 webview features a storefront has enabled, for the
 * GA4 `webview_features` dimension. The denominator for adoption charts.
 */
export const getWebviewFeatures = (config: IConfig | undefined): string => {
  if (!config) return ''

  const features: string[] = []
  const { checkoutRuleRoutes, options, routes, containers } = config

  if (checkoutRuleRoutes?.[CheckoutRules.DELIVERY_DATES]) {
    features.push('delivery_picker')
  }
  if (checkoutRuleRoutes?.[CheckoutRules.PAYMENT_METHODS]) {
    features.push('payment_picker')
  }
  if (options?.inWebviewOrderConfirmation === true) {
    features.push('order_confirmation')
  }
  if (
    routes?.some(
      (entry) => containers?.[entry.container]?.type === 'orderHistory',
    )
  ) {
    features.push('order_history')
  }

  return features.sort().join(',')
}
